module.exports = __webpack_public_path__ + "img/lao.0f124ae3.svg";